// extracted by mini-css-extract-plugin
export default {"mainStyle":"FAQ_mainStyle__xcLqJ"};